var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2368 96.6667C70.4922 89.3394 85.6414 72.3089 88.0188 50.6243C88.678 41.211 88.6219 31.7613 87.851 22.3564C87.7492 20.874 87.0985 19.4828 86.026 18.4544C84.9535 17.426 83.5362 16.8342 82.0509 16.7946C72.435 16.4985 61.2601 14.8962 52.6235 6.38856C51.7212 5.49881 50.5049 5 49.2377 5C47.9705 5 46.7542 5.49881 45.8519 6.38856C37.2143 14.8952 26.0394 16.4985 16.4248 16.7946C14.9394 16.8342 13.5221 17.426 12.4496 18.4544C11.3771 19.4828 10.7265 20.874 10.6246 22.3564C9.85302 31.7612 9.79621 41.211 10.4547 50.6243C12.8321 72.3089 27.9814 89.3394 49.2368 96.6667Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 50.7902L42.0833 58.8828C43.3871 60.3724 45.5017 60.3724 46.8056 58.8828L63.3333 40",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChild);
export default __webpack_public_path__ + "static/media/area_child.d8f3c402f8002be5bf863e2e0aa1f5f3.svg";
export { ForwardRef as ReactComponent };